import Axios from 'axios';

export const getProfileByIdOrSlug = (idOrSlug) => {
  return Axios.get(`${process.env.ACTIVITIES_API_PREFIX}/profile?id=${idOrSlug}`)
    .then((response) => response?.data)
    .catch(() => undefined);
};
